import { useState, useEffect } from 'react';

let _addToast = null;

export function showToast(message, type = 'info') {
  if (_addToast) _addToast({ message, type, id: Date.now() + Math.random() });
}

const ACCENT = { success: '#22c55e', error: '#ef4444', info: '#3b82f6' };

export function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    _addToast = ({ message, type, id }) => {
      setToasts(prev => [...prev, { message, type, id }]);
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
    };
    return () => { _addToast = null; };
  }, []);

  if (!toasts.length) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '24px', right: '24px',
      zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '8px',
    }}>
      {toasts.map(t => (
        <div key={t.id} style={{
          background: '#1e293b',
          color: '#f1f5f9',
          padding: '12px 18px',
          borderRadius: '10px',
          fontSize: '0.875em',
          fontWeight: '500',
          lineHeight: '1.4',
          boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
          borderLeft: `3px solid ${ACCENT[t.type] || ACCENT.info}`,
          maxWidth: '340px',
        }}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
